export default __webpack_public_path__ + "static/media/q2_step2.f043fcde.png";